export default "__VITE_ASSET__d452e6e0__"